<template>
	<div class="revisions" ref="revisionRef">
		<a href="#" class="revisions-trigger dd-link"><strong>{{ revisions.length }}</strong> {{getRevisionPluralize}}</a>

		<div class="revisions-items dd" ref="ddRef">
			<ul>
				<revision :revision="revision" :is-current="isCurrentRevision(revision)" v-for="revision in revisions" :track-by="revision.token"></revision>
			</ul>
		</div>
	</div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import Revision from './Revision.vue';

export default {
    props: {
        revisions: {
            type: Array,
            required: true
        },

        current: {
            type: Object,
            required: true
        }
    },

    computed: {
        getRevisionPluralize() {
            return 'Revision' +  (this.revisions.length > 1 ? 's' : '');
        }
    },

    components: {
        Revision
    },

    methods: {
        isCurrentRevision: function(revision) {
            return revision.token === this.current.token;
        }
    },

    setup() {
        const isOpen = ref(false);
        const revisionRef = ref(null);
        const ddRef = ref(null);
        const observer = ref(null);

        onMounted(() => {
            observer.value = new MutationObserver((mutationsList) => {
                const mutation = mutationsList[0];
                isOpen.value = mutation.target.style.display === 'none';
                if(mutation.target.style.display === 'none') {
                    revisionRef.value.classList.remove('selected')
                }
            });

            observer.value.observe(ddRef.value, { attributes: true });

            onBeforeUnmount(() => {
                observer.value.disconnect();
            });
        });
        

        return {
            ddRef,
            observer,
            isOpen,
            revisionRef
        };
    },
}
</script>